import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Splash() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0A0B07]"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          <motion.div
            className="relative"
            initial={{ scale: 0.7, opacity: 0, y: 8 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="absolute inset-0 rounded-[28px] bg-emerald-400/25 blur-2xl" />
            <img
              src="/icon-512.png"
              alt="SMART Momentum"
              className="relative w-28 h-28 sm:w-32 sm:h-32 rounded-[28px] ring-1 ring-emerald-400/30 shadow-2xl"
            />
          </motion.div>

          <motion.div
            className="mt-7 text-center"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.5 }}
          >
            <div className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">
              <span className="text-emerald-400">SMART</span> <span className="text-white">Momentum</span>
            </div>
            <p className="mt-2 text-xs sm:text-sm text-white/60">
              Small Meaningful Actions Repeated Today
            </p>
          </motion.div>

          <motion.div
            className="mt-9 h-0.5 w-32 overflow-hidden rounded-full bg-white/10"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            <motion.div
              className="h-full bg-emerald-400"
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ delay: 0.45, duration: 1.2, ease: "easeInOut" }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
